import { Component } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { findParent } from '../../helpers/objects';

@Component
export class WmsRouter extends BaseComponent {
	elementClickListener: any = this.elementClicked.bind(this);

	mounted() {
		window.addEventListener('click', this.elementClickListener);
	}

	destroyed() {
		window.removeEventListener('click', this.elementClickListener);
	}

	elementClicked(event: MouseEvent) {
		const anchor = findParent<HTMLElement>(event.target as HTMLElement, 'parentElement', (element) => {
			return element.tagName.toLowerCase() === 'a';
		}) as HTMLAnchorElement;

		if (!anchor) {
			return;
		}

		// TODO emit anchor click
		this.$root.$emit('anchor-click', event, anchor);

		if (anchor.getAttribute('href') && anchor.getAttribute('href').match(/^mailto:/)) {
			(window as any).trackMailClick && (window as any).trackMailClick();
		}

		if (anchor.getAttribute('href') && anchor.getAttribute('href').match(/^tel:/)) {
			(window as any).trackPhoneClick && (window as any).trackPhoneClick();
		}

		if (
			event.defaultPrevented
			|| event.button !== 0
			|| event.altKey || event.ctrlKey || event.shiftKey || event.metaKey
			|| (anchor.host && anchor.host !== window.location.host)
			|| anchor.getAttribute('href') && anchor.getAttribute('href').match(/^(mailto|tel):/)
			|| anchor.getAttribute('href') && anchor.getAttribute('href').startsWith('#')
			|| anchor.search.match('jv=[0-9]')
		) {
			return;
		}

		event.preventDefault();

		// HACK: send some metadata with navigation
		(this.$router as any).meta = {
			afterClick: true
		};

		this.$router.push(anchor.pathname + anchor.search + anchor.hash);
	}
}

export default WmsRouter;
